import { Time } from "@angular/common";
import { AttachedDocumentDTO, AttachmentDTO, LookupItemDTO } from "../../../shared/api-common-models";
import { EmailEditorDTO } from "../../../shared/email/models/api-models";

export interface ReviewApplicationInitDTO {
  requisitionTitle: string;
  requisitionNumber: string;
  entityName: string;
  statusName: string;
  reviewStartDate: Date | null;
  steps: SelectionStepDTO[];
  candidateEmail: string;
  applicationDate: Date;
  canStart: boolean;
  canClose: boolean;
  isStepDisabled: boolean;
  isStepCompleted: boolean;
  hasCandidatePack: boolean;
  isLinkedApplication: boolean;
  canLockFeedbackForm: boolean;
  attachedDocuments: AttachedDocumentDTO[];
  isDataDeleted: boolean;
  sourceApplicationId?: number;
  canReviewApplication: boolean;
  canUpdateApplicationStatus: boolean;
  hasApplicationFormsHistory: boolean;
  applicationFormId: number;
  isFirstReview: boolean;
}
export interface SelectionStepDTO {
  selectionStepId: number;
  stepName: string;
  status: string;
  order: number;
  isFeedbackVisible: boolean;
  isFeedbackEnabled: boolean;
  hasFeedback: boolean;
  isStartVisible: boolean;
  isStartEnabled: boolean;
  isPostponeVisible: boolean;
  isPostponeEnabled: boolean;
  isCancelVisible: boolean;
  isCancelEnabled: boolean;
  isRejectVisible: boolean;
  isRejectEnabled: boolean;
  isCommentVisible: boolean;
  isCommentEnabled: boolean;
  hasComments: boolean;
  isAddDocumentsVisible: boolean;
  isAddDocumentsEnabled: boolean;
  documents: StepDocumentDTO[];
  isWithdrawVisible: boolean;
  isWithdrawEnabled: boolean;
  isWithdrawn: boolean;
  isFeedbackRequest: boolean;
  isCvReview: boolean;
  isStepDisabled: boolean;
  isStepCompleted: boolean;
  isRejected: boolean;
  defaultEmailTemplateId: number | null;
  meetingRequests: MeetingRequestListItemDTO[];
  feedbackRequests: FeedbackRequestDTO[];
  activeFeedbackRequestId: number;
  activeFeedbackCreatedDate: Date;
  activeFeedbackRequestCreatedDate: Date;
}

export interface FeedbackRequestDTO {
  feedbackRequestId: number;
  index: number;
  answeredFeedbacksCount: number;
  usersCount: number;
  canceled: number;
  canceledFeedbacksCount: number;
}

export interface MeetingRequestListItemDTO {
  meetingRequestId: number;
  index: number;
  meetingDate: Date;
  meetingTime: Time;
  status: string;
  isCanceled: boolean;
}

export interface CommentListItemDTO {
  commentId: number;
  comment: string;
  ownerUser: string;
  relatedStepName: string;
  createdDate: Date;
  canEdit: boolean;
  lastModifiedDate: string | null;
  attachments: AttachmentDTO[];
}

export interface StepDocumentDTO {
  title: string;
  downloadUrl: string;
}

export interface CommentEditorInitDTO {
  commentId: number;
  comment: string;
  attachments: AttachmentDTO[];
}

export interface CommentListItemDTO {
  commentId: number;
  comment: string;
  ownerUser: string;
  relatedStepName: string;
  createdDate: Date;
  canEdit: boolean;
  lastModifiedDate: string | null;
  attachments: AttachmentDTO[];
}

/** step feedback permissions models */
export interface StepFeedbackPermissionsInitDTO {
  selectionStepFeedbackPermissionId: number;
  allowedToUserIds: number[];
  allUsers: LookupItemDTO<any>[];
}

export interface SaveStepFeedbackPermissionsDTO {
  selectionStepId: number;
  applicationId: number;
  applicationFeedbackType: ApplicationFeedbackType;
  allowedToUserIds: number[];
}
/** end of step feedback permissions models */

/**Meeting Request models*/
/** data needed to load the editor in new mode */
export interface MeetingRequestEditorInitDTO {
  participants: LookupItemDTO<any>[];
  meetingLocations: LookupItemDTO<any>[];
  defaultParticipantsIds: number[];
  defaultEmailTemplateId: number | null;
  timeZones: LookupItemDTO<any>[];
  recruiterDefaultTimeZoneId: number;
  allowedEmailTemplateIds: number[];
  showEmailCC: boolean;
  isOnline: boolean;
}

export interface EditMeetingRequestEditorInitDTO {
  emptyInitiationData: MeetingRequestEditorInitDTO;
  meetingDate: Date;
  meetingTime: Time;
  meetingDuration: number;
  participantsIds: number[];
  locationEntityId: number | null;
  meetingTimeZoneId: number;
  meetingLocation: string;
  email: EmailEditorDTO;
  emailTemplateId?: number;
  isCanceled: boolean;
  canEdit: boolean;
}

/**
 * Represents the type of feedback when reviewing an application
 */
export enum ApplicationFeedbackType {
  StepFeedback = 1,
  ReferenceFeedback = 2
}

/**End of Meeting Request models*/
